import { render, staticRenderFns } from "./_PostDonationTransferHistory.vue?vue&type=template&id=20dd0644"
import script from "./_PostDonationTransferHistory.vue?vue&type=script&lang=ts"
export * from "./_PostDonationTransferHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/PostDonation.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fprototypes%2Fliving_donor%2Forgans%2F_PostDonationTransferHistory.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports